import styled from 'styled-components';
import { COLORS } from '../../constants/radar';

export const Container = styled.div`
  padding: 24px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.BACKGROUND_PRIMARY};
  position: absolute;
  left: 0;
  right: 0;
  overflow: hidden;
  box-sizing: border-box;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  background: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: ${COLORS.SECONDARY};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${COLORS.BACKGROUND};
    color: ${COLORS.PRIMARY};
    transform: translateX(-2px);
  }

  svg {
    font-size: 16px;
  }
`;

export const Title = styled.h1`
  color: ${COLORS.PRIMARY};
  font-size: 24px;
  margin: 0;
  font-weight: 600;
  position: relative;
  padding-left: 16px;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 24px;
    width: 4px;
    background-color: ${COLORS.PRIMARY};
    border-radius: 2px;
  }
`;

export const HeaderButton = styled.button`
  padding: 8px 16px;
  background-color: white;
  color: ${COLORS.PRIMARY};
  border: 1px solid ${COLORS.PRIMARY};
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  white-space: nowrap;
  
  &:hover {
    background-color: ${COLORS.PRIMARY};
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: scale(1.1);
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  height: calc(100vh - 100px);
  overflow: hidden;
  position: relative;
  
  > div {
    position: relative;
  }
`;

export const ChartPanel = styled.div`
  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  overflow: auto;
  position: relative;
  z-index: 1;
  
  > div {
    flex: 1;
    width: 100%;
    height: auto;
    min-height: 500px;
    position: relative;
    z-index: 1;
  }
`;

export const SelectionsContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-end;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;

  select {
    width: 100%;
    padding: 8px;
    border: 1px solid ${COLORS.BACKGROUND};
    border-radius: 4px;
    font-size: 14px;
    
    &:focus {
      outline: none;
      border-color: ${COLORS.SECONDARY};
    }
  }
`;

export const Label = styled.label`
  color: ${COLORS.PRIMARY};
  font-weight: 500;
  font-size: 14px;
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 1rem;
  padding: 0 16px;
`;

export const TabButton = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  background: none;
  cursor: pointer;
  color: ${({ active }) => active ? COLORS.PRIMARY : COLORS.SECONDARY};
  transition: all 0.2s ease;
  font-weight: ${({ active }) => active ? '600' : '400'};
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${({ active }) => active ? COLORS.PRIMARY : 'transparent'};
  }

  &:hover {
    color: ${COLORS.PRIMARY};
  }

  &:focus {
    outline: none;
  }
`;

export const TagSelectorModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
`;

export const TagSelectorContent = styled.div`
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1000000;
`;

export const TagSelectorHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  
  h3 {
    margin: 0;
    color: ${COLORS.PRIMARY};
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: ${COLORS.SECONDARY};
  padding: 4px 8px;
  
  &:hover {
    color: ${COLORS.PRIMARY};
  }
`;